module.exports = __webpack_public_path__ + "img/8.13aa4ed4.png";